"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-wrap app-error"
  }, [_vm._m(0), _c('span', {
    staticClass: "app-error-text"
  }, [_vm._v(_vm._s(_vm.error))])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h2', [_vm._v("Une erreur est survenue au démarrage d'"), _c('span', {
    staticClass: "app-name"
  }, [_vm._v("AppChat")])]);
}];